export default function DOM_Document() {
  return (
    <div>
      <h1>DOM_Document</h1>
      <p>This is the DOM_Document component.</p>
    </div>
  );
}